var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import MuiButton from '@material-ui/core/Button';
import units from '../theme/units';
var useStyles = makeStyles(function () { return ({
    'iconSize-inherit': {
        '& > *:first-child': {
            fontSize: 'inherit',
        },
    },
    'iconSize-small': {
        '& > *:first-child': {
            fontSize: units.rem(0.5),
        },
    },
    'iconSize-large': {
        '& > *:first-child': {
            fontSize: units.rem(1.875),
        },
    },
}); });
var Button = React.forwardRef(function (_a, ref) {
    var iconSize = _a.iconSize, classes = _a.classes, rest = __rest(_a, ["iconSize", "classes"]);
    var customClasses = useStyles();
    var newClasses = __assign(__assign({}, classes), { startIcon: cx(classes && classes.startIcon, customClasses["iconSize-" + iconSize]), endIcon: cx(classes && classes.endIcon, customClasses["iconSize-" + iconSize]) });
    return React.createElement(MuiButton, __assign({}, rest, { ref: ref, classes: newClasses }));
});
export default Button;
//# sourceMappingURL=index.js.map